

var init = function (element) {
    var YTAPIStatus = false;
    var VimeoAPIStatus = false;

    var YTQue = [];
    var VimeoQue = [];

    var vijsready = false;
    var $elem = element;
    var url = $elem.dataset.video;
    var playBtn = element.querySelector('[data-video-button]');

    console.log('playBtn', playBtn);

    var _public = {};

    var manageSlideshow = function manageSlideshow($slideshow) {
        _public.$parentSlideshow = $slideshow;

        $slideshow.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            if (_public.player && _public.player.getPlayerState() === 1) {
                _public.player.pauseVideo();
            }
        });
    };


    var onPlayerReady = function onPlayerReady(type) {
        // Put stuff to handle video ready here
        // var $slideshowParent = $elem.closest('[data-video-slideshow]');
        // if($slideshowParent) {
        //     if(vijsready) {
        //         manageSlideshow($slideshowParent);
        //     } else {
        //         $(document).on('vijs:init', function(){
        //             manageSlideshow($slideshowParent);
        //         });
        //     }
        // }


        fluidvids.init({
            selector: ['[data-modal-carousel-item] iframe'], // runs querySelectorAll()
            players: ['www.youtube.com', 'player.vimeo.com'] // players to support
        });

        if (playBtn) {
            playBtn.addEventListener('click', function () {
                element.classList.add('is-playing');
                console.log('_public.player', _public.player);
                if (type === 'vimeo') {
                    _public.player.play();
                } else {
                    _public.player.playVideo();
                }
            });
        }

        document.addEventListener("pause-video", function (e) {
            if (type === 'vimeo') {
                _public.player.pause();
            } else {
                _public.player.pauseVideo();
            }
        });
    };

    var onPlayerStateChange = function onPlayerStateChange(status) {
        if (status.data === 1) {
            element.classList.add('is-playing');
        }
        if (status.data === 2) {
            element.classList.remove('is-playing');
        }
        // if (_public.$parentSlideshow) {
        //     if (status.data === 1) _public.$parentSlideshow.slick('slickPause');
        //     if ((status.data === 0 || status.data === 2) && _public.settings.parentSlideshowAutoplay) {
        //         _public.$parentSlideshow.slick('slickPlay');
        //     }
        // }
    };

    var loadYTAPI = function loadYTAPI() {
        YTAPIStatus = 'loading';
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = function () {
            YTAPIStatus = 'loaded';
            YTQue.forEach(function (item) {
                item();
            });
        };
    };

    loadVimeoAPI = function () {
        VimeoAPIStatus = 'loading';
        var tag = document.createElement('script');
        tag.src = "https://player.vimeo.com/api/player.js";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        function waitForVimeo() {
            if (typeof Vimeo !== "undefined") {
                //variable exists, do what you want
                VimeoAPIStatus = 'loaded';
                VimeoQue.forEach(function (item) {
                    item();
                });
            }
            else {
                setTimeout(waitForVimeo, 5);
            }
        }
        waitForVimeo();
    };

    var getIDFromYT = function (url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);
        var videoId = match ? match[2] : false;
        if (!videoId) {
            console.warn('videoOverlay: Unable to get videoID from URL: ' + url + ". Video will not load");
            return false;
        }
        return videoId;
    };

    var initYTOnReady = function () {
        var iframe = document.createElement('div');
        $elem.appendChild(iframe);
        _public.player = new YT.Player(iframe, {
            width: '1162',
            height: '654',
            videoId: getIDFromYT(url),
            events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange
            },
            playerVars: {
                rel: 0
            }
        });
    };

    var initVimeoOnReady = function () {
        var iframe = document.createElement('div');
        element.appendChild(iframe);

        var id = url.replace('https://vimeo.com/', '');

        _public.player = new Vimeo.Player(iframe, {
            id: id
        });

        _public.player.ready().then(function () {
            // $elem.fitVids(); // glitchy
            onPlayerReady('vimeo');
        });

    };

    if (url && url.toLowerCase().indexOf('youtube') !== -1) {
        if (YTAPIStatus === 'loading') {
            YTQue.push(initYTOnReady);
        } else if (YTAPIStatus === false) {
            YTQue.push(initYTOnReady);
            loadYTAPI();
        } else {
            initYTOnReady();
        }
    } else if (url && url.toLowerCase().indexOf('vimeo') !== -1) {
        if (VimeoAPIStatus === 'loading') {
            VimeoQue.push(Vimeo);
        } else if (VimeoAPIStatus === false) {
            VimeoQue.push(initVimeoOnReady);
            loadVimeoAPI();
        } else {
            initVimeoOnReady();
        }
    }

}

window.videolauncher = init

// your page initialization code here
// the DOM will be available here
var videos = document.querySelectorAll('[data-video]');
if (videos) {
    for (var i = 0; i < videos.length; i++) {
        var vid = videos[i];
        init(vid)
    }
}

// init();

